/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_SubtitleInputs */

const en_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Six steps grounded in physics, anatomy, and motor learning, not inherited swing dogma. Built from three decades of teaching at every level of the game.`)
};

const es_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seis pasos fundamentados en física, anatomía y aprendizaje motor, no en dogmas heredados del swing. Construido con tres décadas de enseñanza en todos los niveles del juego.`)
};

const de_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sechs Schritte, die auf Physik, Anatomie und motorischem Lernen basieren, nicht auf einem ererbten Swing-Dogma. Entwickelt aus drei Jahrzehnten Unterricht auf allen Ebenen des Spiels.`)
};

const zh_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`六个步骤基于物理学、解剖学和运动学习，而不是继承的挥杆教条。经过三十年对各个级别比赛的教学积累而成。`)
};

const ar_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ست خطوات متجذرة في الفيزياء والتشريح وتعلّم الحركة، لا عقائد السوينغ الموروثة. مبنية من ثلاثة عقود من التعليم على كل مستويات اللعبة.`)
};

const fr_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Six étapes fondées sur la physique, l'anatomie et l'apprentissage moteur, et non sur un dogme du swing hérité. Construit à partir de trois décennies d’enseignement à tous les niveaux du jeu.`)
};

const vi_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sáu bước dựa trên vật lý, giải phẫu, và học vận động, không phải giáo điều swing kế thừa. Được xây dựng từ ba thập kỷ giảng dạy ở mọi cấp độ của môn chơi.`)
};

const sw_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hatua sita zimeegemezwa katika fizikia, anatomia, na ujifunzaji wa mwendo, sio mafundisho ya kurithi ya swing. Imejengwa kutoka kwa miongo mitatu ya ufundishaji katika kila ngazi ya mchezo.`)
};

const th_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หกขั้นตอนที่มีพื้นฐานมาจากฟิสิกส์ กายวิภาคศาสตร์ และการเรียนรู้ด้านการเคลื่อนไหว ไม่ใช่หลักสวิงที่สืบทอดมา สร้างจากการสอนตลอดสามทศวรรษในทุกระดับของเกม`)
};

const bs_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šest koraka utemeljenih u fizici, anatomiji i motoričkom učenju, ne u naslijeđenim dogmama o zamahu. Izgrađeno kroz tri decenije poučavanja na svim nivoima igre.`)
};

const ja_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物理学・解剖学・運動学習に基づく6つのステップ。受け継いだスイング教義ではありません。あらゆるレベルでの30年の指導から築かれました。`)
};

const ko_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`물리학·해부학·운동학습에 기반한 여섯 단계. 물려받은 스윙 교리가 아닙니다. 모든 수준의 게임에서 쌓아온 30년 가르침으로 만들었습니다.`)
};

const pt_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seis passos baseados em física, anatomia e aprendizagem motora — não dogma de swing herdado. Construído a partir de três décadas de ensino em todos os níveis do jogo.`)
};

const it_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei passi fondati sulla fisica, sull'anatomia e sull'apprendimento motorio, non su dogmi dello swing ereditati. Nati da tre decenni di insegnamento a ogni livello di gioco.`)
};

const sv_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sex steg grundade i fysik, anatomi och motorisk inlärning – inte i nedärvda svingdogmer. Byggda på tre decenniers undervisning på alla nivåer av spelet.`)
};

const nl_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zes stappen geworteld in natuurkunde, anatomie en motorisch leren — geen geërfd swing-dogma. Gebouwd uit drie decennia lesgeven op elk niveau van het spel.`)
};

const da_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seks trin baseret på fysik, anatomi og motorisk læring – ikke på nedarvede svingdogmer. Bygget på tre årtiers undervisning på alle niveauer af spillet.`)
};

const nb_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seks steg forankret i fysikk, anatomi og motorisk læring – ikke i nedarvede svingdogmer. Bygget på tre tiår med undervisning på alle nivåer av spillet.`)
};

const fi_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuusi askelta, jotka perustuvat fysiikkaan, anatomiaan ja motoriseen oppimiseen – eivät perittyyn svingidogmaan. Rakennettu kolmen vuosikymmenen opetuskokemuksesta pelin kaikilla tasoilla.`)
};

const pl_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sześć kroków opartych na fizyce, anatomii i nauce motorycznej, a nie na odziedziczonych dogmatach swingu. Metoda zbudowana na trzech dekadach nauczania na każdym poziomie gry.`)
};

const ru_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шесть шагов, основанных на физике, анатомии и моторном обучении, а не на унаследованной догме свинга. Построены на основе трёх десятилетий обучения на всех уровнях игры.`)
};

const tr_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizik, anatomi ve motor öğrenmeye dayanan altı adım — miras sving dogması değil. Oyunun her seviyesinde otuz yıllık öğretimden inşa edildi.`)
};

const hi_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भौतिकी, शरीर रचना और मोटर लर्निंग पर आधारित छह चरण—विरासत में मिली स्विंग की रूढ़ियों पर नहीं। खेल के हर स्तर पर तीन दशकों के शिक्षण से निर्मित।`)
};

const id_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enam langkah berlandaskan fisika, anatomi, dan pembelajaran motorik, bukan dogma ayunan warisan. Dibangun dari tiga dekade mengajar di setiap tingkat permainan.`)
};

const ms_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enam langkah berasaskan fizik, anatomi dan pembelajaran motor, bukan dogma hayunan warisan. Dibina daripada tiga dekad pengajaran di setiap peringkat permainan.`)
};

const cs_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šest kroků zakotvených ve fyzice, anatomii a motorickém učení, ne ve zděděném dogmatu švihu. Vychází ze tří desetiletí výuky na všech úrovních hry.`)
};

const el_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έξι βήματα βασισμένα στη φυσική, την ανατομία και τη μάθηση κινήσεων — όχι σε κληροδοτημένα δόγματα του σουίνγκ. Χτισμένα πάνω σε τρεις δεκαετίες διδασκαλίας σε κάθε επίπεδο του παιχνιδιού.`)
};

const he_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שישה שלבים המבוססים על פיזיקה, אנטומיה ולמידה מוטורית, ולא על דוגמות סווינג שעברו בירושה. נבנו מתוך שלושה עשורים של הוראה בכל רמות המשחק.`)
};

const af_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ses stappe gegrond in fisika, anatomie en motoriese leer, nie oorgeërfde swaai-dogma nie. Gebou uit drie dekades onderrig op elke vlak van die spel.`)
};

const hu_method_subtitle = /** @type {(inputs: Method_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat lépés fizikából, anatómiából és motoros tanulásból, nem örökölt lendítés-dogmából. Három évtizednyi tanításból épült a játék minden szintjén.`)
};

/**
* | output |
* | --- |
* | "Six steps grounded in physics, anatomy, and motor learning, not inherited swing dogma. Built from three decades of teaching at every level of the game." |
*
* @param {Method_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_subtitle = /** @type {((inputs?: Method_SubtitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_SubtitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_subtitle(inputs)
	if (locale === "de") return de_method_subtitle(inputs)
	if (locale === "zh") return zh_method_subtitle(inputs)
	if (locale === "ar") return ar_method_subtitle(inputs)
	if (locale === "fr") return fr_method_subtitle(inputs)
	if (locale === "vi") return vi_method_subtitle(inputs)
	if (locale === "sw") return sw_method_subtitle(inputs)
	if (locale === "th") return th_method_subtitle(inputs)
	if (locale === "bs") return bs_method_subtitle(inputs)
	if (locale === "ja") return ja_method_subtitle(inputs)
	if (locale === "ko") return ko_method_subtitle(inputs)
	if (locale === "pt") return pt_method_subtitle(inputs)
	if (locale === "it") return it_method_subtitle(inputs)
	if (locale === "sv") return sv_method_subtitle(inputs)
	if (locale === "nl") return nl_method_subtitle(inputs)
	if (locale === "da") return da_method_subtitle(inputs)
	if (locale === "nb") return nb_method_subtitle(inputs)
	if (locale === "fi") return fi_method_subtitle(inputs)
	if (locale === "pl") return pl_method_subtitle(inputs)
	if (locale === "ru") return ru_method_subtitle(inputs)
	if (locale === "tr") return tr_method_subtitle(inputs)
	if (locale === "hi") return hi_method_subtitle(inputs)
	if (locale === "id") return id_method_subtitle(inputs)
	if (locale === "ms") return ms_method_subtitle(inputs)
	if (locale === "cs") return cs_method_subtitle(inputs)
	if (locale === "el") return el_method_subtitle(inputs)
	if (locale === "he") return he_method_subtitle(inputs)
	if (locale === "af") return af_method_subtitle(inputs)
	if (locale === "hu") return hu_method_subtitle(inputs)
	return en_method_subtitle(inputs)
});